import React from "react";
import ProjectTour from "./ProjectTour";
import { useState, useEffect } from "react";
import {summarydashboardsteps} from '../../tours/SummaryDashboardSteps';
import {timelinesteps} from '../../tours/TimelineSteps';
import {backlogsteps} from '../../tours/BacklogSteps';
import {boardsteps} from '../../tours/BoardSteps';
import {liststeps} from '../../tours/ListSteps';
import httpInjectorService from "services/http-injector.service";

const ProjectTourProvider = ({ activeTab,
    setActiveTab,}) => {
     const [runTour, setRunTour] = useState(false);
    const [tourSteps, setTourSteps] = useState([]);
    const [tourKey, setTourKey] = useState(0);  
const hasStartedRef = React.useRef(false);
const finishHandledRef = React.useRef(false);
const inFlightRef = React.useRef(null); 
   

//     useEffect(() => {
//         console.log("ProjectTourProvider mounted");
//   if (
//     sessionStorage.getItem("project-auto-tour") === "true"
//   ) {
//     startTourForTab(activeTab);
//   }
// }, [activeTab]);

// run once on mount only

useEffect(() => {
  const hasSeenTour = localStorage.getItem("has-seen-project-tour") === "true";
  if (!hasSeenTour && !hasStartedRef.current) {
    hasStartedRef.current = true;
    startTourForTab(activeTab);
  }
}, []);
    
    
    
    const tabStepsMap = {
      summaryDashboard:summarydashboardsteps(),
      Timeline:timelinesteps(),
      backlog:backlogsteps(),
      board: boardsteps(),
      list:liststeps(),
    };
    
    const tabFlow = [
      'summaryDashboard',
      'Timeline',
      'backlog',
      'board',
      'list',
    ];
    
    // useEffect(() => {
    //   if (!runTour && tourSteps.length > 0) {
    //     startTourForTab(activeTab);
    //   }
    // }, [activeTab]);
    useEffect(() => {
  
}, [activeTab]);
    
    // const startTourForTab = (tab) => {
    //   const steps = tabStepsMap[tab];
    
    //   if (!steps) return;
    
    //   setTimeout(() => {
    //     const validSteps = steps.filter(step =>
    //       document.querySelector(step.target)
    //     );
    
    //     setTourSteps(validSteps);
    //     setRunTour(true);
    //   }, 500);
    // };
    
//    const startTourForTab = (tab, retry = 0) => {
//   const steps = tabStepsMap[tab];

//   if (!steps) return;

//   const validSteps = steps.filter(step =>
//     document.querySelector(step.target)
//   );

//   console.log("Retry:", retry);
//   console.log("Valid:", validSteps.length);

//   if (validSteps.length === 0 && retry < 10) {
//     setTimeout(() => startTourForTab(tab, retry + 1), 300);
//     return;
//   }

//  if (validSteps.length > 0) {
//     setTourSteps(validSteps);
//     setRunTour(true);

//     // force Joyride to recalculate spotlight position against real layout
//     requestAnimationFrame(() => {
//       window.dispatchEvent(new Event('resize'));
//     });
//   }
// };

// const startTourForTab = (tab, retry = 0) => {
//   const steps = tabStepsMap[tab];

//   if (!steps) return;

//   const validSteps = steps.filter(step =>
//     document.querySelector(step.target)
//   );

//   if (validSteps.length === 0 && retry < 10) {
//     setTimeout(() => startTourForTab(tab, retry + 1), 300);
//     return;
//   }

//   if (validSteps.length > 0) {
//     // give charts/async content time to finish painting before measuring
//     setTimeout(() => {
//       setTourSteps(validSteps);
//       setRunTour(true);

//       requestAnimationFrame(() => {
//         window.dispatchEvent(new Event('resize'));
//       });
//     }, 400); // adjust up if charts still shift after this
//   }
// };

const updateProjectTourStatus = async () => {
    try {
      const payload = { has_seen_project_tour: true };
      await httpInjectorService.updateProjectTourStatus(payload);
    } catch (error) {
      console.error('Failed to update tour status', error);
    }
  };

  const handleProjectTourClose = async () => {
  try {
    await updateProjectTourStatus();
    setRunTour(false);
    setTourSteps([]);
   
    localStorage.removeItem("has-seen-project-tour");
    localStorage.setItem("has-seen-project-tour", "true");
  } catch (error) {
    console.error(error);
  }
};



const startTourForTab = (tab, retry = 0) => {
if (retry === 0 && startTourForTab._inFlight === tab) {
    return;
  }
  inFlightRef.current = tab;
  const steps = tabStepsMap[tab];
  if (!steps) return;
  steps.forEach((step, index) => {
    const element = document.querySelector(step.target);

  
  });

 const validSteps = steps.filter(step =>
    document.querySelector(step.target)
  );

 

  if (validSteps.length < steps.length && retry < 15) {
    setTimeout(() => startTourForTab(tab, retry + 1), 300);
    return;
  }

 if (validSteps.length > 0) {
  // Reset Joyride first
  setRunTour(false);
  setTourSteps([]);

  setTimeout(() => {
    setTourKey(prev => prev + 1);
    setTourSteps(validSteps);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setRunTour(true);

        window.dispatchEvent(new Event("resize"));
        inFlightRef.current = null;
      });
    });
  }, 600);
}
};

// useEffect(() => {
//   const restartTour = () => {
//     console.log("Restarting Project Tour");

//     localStorage.removeItem("has-seen-project-tour");
//     hasStartedRef.current = false;
//     finishHandledRef.current = false;

//     startTourForTab(activeTab);
//   };

//   window.addEventListener("restart-project-tour", restartTour);

//   return () => {
//     window.removeEventListener("restart-project-tour", restartTour);
//   };
// }, [activeTab]);

useEffect(() => {
  const restartProjectTour = () => {
   

    startTourForTab(activeTab);
  };

  window.addEventListener("restart-project-tour", restartProjectTour);

  return () => {
    window.removeEventListener("restart-project-tour", restartProjectTour);
  };
}, [activeTab]);

  const handleTabTourFinish = async () => {
  if (finishHandledRef.current) return;
  finishHandledRef.current = true;

  setRunTour(false);
  setTourSteps([]);

  const currentIndex = tabFlow.indexOf(activeTab);
  const nextTab = tabFlow[currentIndex + 1];

  if (nextTab) {
    setTimeout(() => {
      setActiveTab(nextTab);
      startTourForTab(nextTab);
      finishHandledRef.current = false;
    }, 500);

  } else {
    try {
      await updateProjectTourStatus();

      localStorage.removeItem("has-seen-project-tour");
      localStorage.setItem("has-seen-project-tour", "true");
    } catch (error) {
      console.error(error);
    }
    finishHandledRef.current = false;
  }
};
  return (
    <>
    <ProjectTour
  key={tourKey}
  run={runTour}
  steps={tourSteps}
  onFinish={handleTabTourFinish}
  onClose={handleProjectTourClose}
/>
    </>

  )
};

export default ProjectTourProvider;